/**
 * Gets code of language considered as default
 * @param {String} domainRegion - current domain region (e.g., `"ru"` or `"com"`)
 * @returns - language code
 */
export default function getDefaultLanguage(domainRegion) {
  return domainRegion === "ru" ? "ru" : "en";
}
